import { EntireComposerState } from './composer';
import { blankDrawingState } from '../../drawing/reducers/drawing';
import { ComposerMode, PagePicture, ClipbookState } from '../types';
import { resetView } from './view';
import { PictureItem, createLivePictureItem } from '../../drawing/reducers/pictureStorage';

export function addNewPage(
  state: EntireComposerState,
  uniqueID: string,
  backgroundID: string,
  width: number,
  height: number,
): EntireComposerState {
  if (state.clipbook === null) {
    throw new Error('Illegal state.');
  }

  const pages = state.clipbook.pages.slice();
  pages.push({ uniqueID, backgroundID, width, height });

  const drawings = { ...state.drawings };
  drawings[uniqueID] = blankDrawingState;

  const intermediateState = {
    ...state,
    drawings,
    mode: ComposerMode.Editing,
    clipbook: {
      ...state.clipbook, pages,
      currentPage: pages.length - 1,
    },
    clipboard: null,
  };
  return resetView(intermediateState);
}

export function addPagePicture(
  state: EntireComposerState,
  id: string,
  blob: Blob,
  url: string,
): EntireComposerState {
  if (id in state.pagePictures.items) {
    throw new Error('Illegal state.');
  }

  const nextItems: { [id: string]: PictureItem<PagePicture> } = { ...state.pagePictures.items };
  nextItems[id] = createLivePictureItem(state.pagePictures, id, { blob, url });
  return { ...state, pagePictures: { ...state.pagePictures, items: nextItems } };
}

export function createIsPageImageDemanded(clipbook: ClipbookState | null) {
  if (clipbook !== null && clipbook.currentPage !== null) {
    const { backgroundID } = clipbook.pages[clipbook.currentPage];
    return (id: string) => id === backgroundID;
  }

  return () => false;
}

export function moveToPage(state: EntireComposerState, page: number): EntireComposerState {
  if (state.clipbook === null) {
    throw new Error('Illegal state.');
  }

  if (state.clipbook.currentPage === page) {
    return state;
  }

  return resetView({
    ...state,
    clipbook: { ...state.clipbook, currentPage: page },
  });
}
